module.exports = __webpack_public_path__ + "img/mission_filter_star.e4d13e48.svg";